class MainTab extends HTMLElement {
    constructor() {
        super();

        const tabBtns = this.querySelectorAll('.tab__title');
        const tabBtnContent = this.querySelectorAll('.tab__description');

        tabBtns.forEach((tabButton, index) => {

            const targetTab = tabButton.getAttribute('data-tab');

            document.addEventListener('DOMContentLoaded', () => {
                if (index === 0) {
                    tabButton.classList.add('active');
                    this.querySelector(`.tab__description[data-tab="${targetTab}"]`).classList.add('active');
                }
            });

            tabButton.addEventListener('click', () => {

                tabBtns.forEach(btn => btn.classList.remove('active'));
                tabBtnContent.forEach(content => content.classList.remove('active'));

                tabButton.classList.add('active');
                document.querySelector(`.tab__description[data-tab="${targetTab}"]`).classList.add('active');
            })
        })

    }
}

customElements.define('main-tab', MainTab);
